import { useState, useCallback } from 'react';
import API from 'api/api';

export default function useRejectTruck() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const rejectTruck = useCallback(async (truckId, payload = {}) => {
    setLoading(true);
    setError(null);

    try {
      await API.put(`/trucks/${truckId}/reject`, payload);
      return true;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { rejectTruck, loading, error };
}
